import { FC, useMemo } from 'react'

import InputItem from '../../../components/InputItem'
import { IEndOfLifeConfiguration } from '../types'
import { getProductOptions } from '../utils'

interface IRecyclingRates {
  formik: any
  configuration: IEndOfLifeConfiguration
}

// One rate per record, because a record already is a country + taxonomy level + product
// combination. The story's category-to-type fallback chain is expressed as sibling records and is
// read off the grid, not nested here.
export const RecyclingRates: FC<IRecyclingRates> = ({ formik, configuration }) => {
  const levelLabel = useMemo(
    () =>
      configuration.productTaxonomyLevel?.find(
        level => level.id === Number(formik.values.productTaxonomyLevel)
      )?.description ?? '',
    [configuration.productTaxonomyLevel, formik.values.productTaxonomyLevel]
  )

  const productLabel = useMemo(
    () =>
      getProductOptions(configuration, Number(formik.values.productTaxonomyLevel) || null).find(
        option => option.id === Number(formik.values.productId)
      )?.name ?? '',
    [configuration, formik.values.productTaxonomyLevel, formik.values.productId]
  )

  return (
    <div className="piece-content-inputs mb-5">
      <InputItem
        disabled
        name="Taxonomy level"
        description="Set on the Country info tab."
        type="input"
        onChange={formik.handleChange}
        formikName="taxonomyLevelDisplay"
        formik={formik}
        defaultValue={levelLabel}
      />
      <InputItem
        disabled
        name="Product"
        description="Set on the Country info tab."
        type="input"
        onChange={formik.handleChange}
        formikName="productDisplay"
        formik={formik}
        defaultValue={productLabel}
      />
      <InputItem
        name="Recycling rate"
        description="Share of this product recycled in this country. Required to publish."
        type="input"
        addonTitle="%"
        onChange={formik.handleChange}
        formikName="recyclingRates"
        formik={formik}
        defaultValue={formik.values.recyclingRates ?? ''}
      />
      <InputItem
        name="Data source comment"
        description=""
        type="text"
        onChange={formik.handleChange}
        formikName="dataSourceComment"
        formik={formik}
        defaultValue={formik.values.dataSourceComment ?? ''}
      />
    </div>
  )
}
